import PageWrapper from "../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import SERecognitionEdit from "../../components/services/secondaryEducation/SERecognitionEdit";

const SERecognitionEditPage = () => {
  const { t } = useTranslation();

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.edit`)}>
      <SERecognitionEdit />
    </PageWrapper>
  );
};

export default SERecognitionEditPage;
